import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllSuppliersUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllSuppliers/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllSuppliersUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllSuppliersUser;
};


const setActiveSuppliers = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setSuppliersActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllSuppliersUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Suppliers  - ',response);


    return AllSuppliersUser;
};



const setDeletedSuppliers = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setSuppliersDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllSuppliersUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Suppliers  - ',response);


    return AllSuppliersUser;
};




const setUpdateSuppliers = async (dataSuppliersUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSuppliersUpdate/'),{
        dataSuppliersUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllSuppliersUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Suppliers  - ',dataSuppliersUpdate,response);


    return AllSuppliersUser;
};


const setSaveNewSuppliers = async (dataSuppliersUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewSuppliers/'),{
        dataSuppliersUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllSuppliersUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Suppliers  - ',response);


    return AllSuppliersUser;
};

Mock.onGet('/api/reference/getAllSuppliers').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllSuppliersUser = await getAllSuppliersUser();
    // console.log('С сервера пришло - ', AllSuppliersUser);

    // if (!AllSuppliersUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllSuppliersUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllSuppliersUser,
    ]


})


Mock.onPost('/api/reference/setActiveSuppliers').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllSuppliersUser = await setActiveSuppliers(id,val);

    // if (!AllSuppliersUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllSuppliersUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllSuppliersUser,
    ]


})

Mock.onPost('/api/reference/setDeletedSuppliers').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllSuppliersUser = await setDeletedSuppliers(id,val);

    // if (!AllSuppliersUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllSuppliersUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllSuppliersUser,
    ]


})


Mock.onPost('/api/reference/setUpdateSuppliers').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataSuppliersUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Suppliers = await setUpdateSuppliers(dataSuppliersUpdate);

    // console.log('Серовер вернул данные ',AllSuppliersUser);

    // if (!Suppliers) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Suppliers) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Suppliers,
    ]


})


Mock.onPost('/api/reference/setSaveNewSuppliers').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataSuppliersUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Suppliers = await setSaveNewSuppliers(dataSuppliersUpdate);

    // console.log('Серовер вернул данные ',AllSuppliersUser);

    // if (!Suppliers) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Suppliers) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Suppliers,
    ]
})